module.exports = __webpack_public_path__ + "static/media/no_gl_seal_light.4624943a.png";